import SortBox from "~/ui/sortbox";
import { node } from "~/util/dom";
import { _ } from "~/i18n";
import { TMyMapsSortOptions } from "~/interfaces";

export const DRAG_AND_DROP_TYPE_ENABLE = "custom";

interface ISortOption {
	title: string;
	value: TMyMapsSortOptions,
}

interface IOpts {
	sortType?: TMyMapsSortOptions;
	items?: "full" | "without-custom";
	onChange?: (value: TMyMapsSortOptions) => void;
}

interface IOutput {
	container: HTMLDivElement;
	setValue: (newValue: TMyMapsSortOptions) => void;
	getValue: () => TMyMapsSortOptions;
}

const CUSTOM_SORT_OPTION: ISortOption = {
	title: "mymap.places.sort.custom",
	value: "custom",
};

const SORT_OPTIONS: Array<ISortOption> = [
	{
		title: "mymap.places.sort.titleAZ",
		value: "alphabetical_asc",
	},
	{
		title: "mymap.places.sort.titleZA",
		value: "alphabetical_desc",
	},
	{
		title: "mymap.places.sort.sortDateDesc",
		value: "time_desc",
	},
	{
		title: "mymap.places.sort.sortDateAsc",
		value: "time_asc",
	},
	{
		title: "mymap.places.sort.sortLengthAsc",
		value: "length_asc",
	},
	{
		title: "mymap.places.sort.sortLengthDesc",
		value: "length_desc",
	},
];

export function buildSortSelectBox({
	sortType = "alphabetical_asc",
	items = "full",
	onChange = () => {},
}: IOpts) {
	let curValue: TMyMapsSortOptions = sortType;
	const options: Array<ISortOption> = [
		...items === "full"
			? [CUSTOM_SORT_OPTION]
			: [],
		...SORT_OPTIONS,
	];
	const sortBox = new SortBox({
		options,
		onSelect: (value: TMyMapsSortOptions) => {
			if (value !== curValue) {
				curValue = value;
				onChange(value);
			}
		},
		//selectedIndex: SORT_OPTIONS.findIndex(option => option.value === this._orderValue),
	});
	const container = node("div", { className: "places-sort-cont" });

	container.append(_("mymap.places.sort.title"), sortBox.node);

	const output: IOutput = {
		container,
		getValue: () => curValue,
		setValue: (newValue: TMyMapsSortOptions) => {
			if (newValue !== curValue) {
				sortBox.value = newValue;
				curValue = newValue;
			}
		},
	};

	sortBox.value = curValue;

	return output;
}
